import { Avatar, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('commonStore', 'menuStore')
@observer
class MenuItem extends Component {
  // 메뉴 클릭시 상세로 이동
  handleMenuItemClick = () => {
    const { location, history, menu, commonStore, menuStore } = this.props;

    if (menu.linkItemCode) {
      menuStore.setSelectedMenu(menu);
      menuStore.openSetItemModal();
    } else {
      history.push(
        `/${commonStore.companyId}/${commonStore.storeCode}/menu-groups/${menu.groupCode}/menus/${menu.itemCode}${location.search}`,
      );
    }
  };

  renderMenuPriceComponent = () => {
    const { i18n, menu } = this.props;

    if (menu.linkMenu) {
      return (
        <div className="price-link-menu">
          <div>
            <span>{i18n.t('menu.label.single')}</span> {this.getMenuPriceComponent(menu)}
          </div>
          <div>
            <span>{i18n.t('menu.label.set')}</span> {this.getMenuPriceComponent(menu.linkMenu)}
          </div>
        </div>
      );
    } else {
      return this.getMenuPriceComponent(menu);
    }
  };

  getMenuPriceComponent = menu => {
    const { menuStore } = this.props;

    const menuPriceInfo = menuStore.getMenuPriceInfo(menu);

    if (menuPriceInfo.discountAmount === 0) {
      // 할인이 없는 경우
      return <CurrencyDisplay amount={menuPriceInfo.discountedAmount} type="emphasis" />;
    } else {
      // 할인이 있는 경우
      return (
        <span className="price-discount-info">
          <CurrencyDisplay amount={menuPriceInfo.discountedAmount} type="emphasis" />
          <CurrencyDisplay amount={menuPriceInfo.price} type="disabled" />
          <span className="emphasis">{menuPriceInfo.discountPercentage}%</span>
        </span>
      );
    }
  };

  render() {
    const { t, menuStore, menu } = this.props;
    return (
      <ListItem
        component="li"
        key={menu.itemCode}
        onClick={this.handleMenuItemClick}
        disableGutters
        button
        dense
        disabled={menu.isSoldOut}
        style={{ padding: '10px 16px' }}
      >
        <ListItemAvatar>
          <Avatar
            src={menuStore.getImageUrl(menu.itemStoreCode, menu.pictureFileName1, menu.pictureFileName2)}
            style={{ width: 70, height: 70 }}
          ></Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Fragment>
              <Typography component="span" variant="subtitle1" color="textPrimary" style={{ fontWeight: 'bold' }}>
                {menu.name}
                {menu.isSoldOut ? ` (${t('menu.label.soldout')})` : ''}
              </Typography>
            </Fragment>
          }
          secondary={this.renderMenuPriceComponent()}
          secondaryTypographyProps={{ component: 'div' }}
          style={{ marginLeft: '16px' }}
        />
      </ListItem>
    );
  }
}

export default withTranslation()(withRouter(MenuItem));
